var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`panel page__${_vm.$route.name.toLowerCase()}`},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"p-0"},[_c('b-col',{staticClass:"p-0 admin_content nice-scroll",attrs:{"cols":"12","lg":"12"}},[_c('div',{staticClass:"content p-2"},[_c('div',{staticClass:"row pl-3 pr-3"},[_c('Table')],1)])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }